import React, { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { Navigate, useLocation, Link } from 'react-router-dom'

import { Button, Input, PageTransition, Icon } from '@components/atoms'
import ToastError from '@components/atoms/Error'
import { SliderLogin } from '@components/molecules'
import { yupResolver } from '@hookform/resolvers/yup'
import { authenticateSchema } from '@schemas/auth/login.schema'
import { authApi } from '@services/AuthApi'
import { authCreators } from '@store/ducks/auth'
import { useAppSelector, useAppDispatch } from '@store/hooks'

import { loginStyles } from './styles'

const { background, container } = loginStyles

type FormValues = {
	email: string
	password: string
}

export default function Login() {
	const {
		register,
		handleSubmit,
		formState: { errors },
	} = useForm<FormValues>({ resolver: yupResolver(authenticateSchema) })

	const {
		auth: { signed, newSession },
		/* 		error: { message, show }, */
	} = useAppSelector((state) => state)
	const { state } = useLocation()
	const dispatch = useAppDispatch()

	const [authenticate, { isSuccess, data }] = authApi.useAuthenticateMutation()

	const onSubmit = handleSubmit((payload) => {
		authenticate(payload)
		dispatch(authCreators.setNewSession())
	})

	useEffect(() => {
		if (isSuccess && data) {
			localStorage.removeItem('popupShown')
			dispatch(authCreators.authenticate({ token: data.token }))
		}
	}, [dispatch, isSuccess, data])

	if (signed && !newSession) {
		return <Navigate to={(state as { redirect: string })?.redirect || '/'} />
	}

	return (
		<PageTransition>
			{signed && (
				<Navigate to={(state as { redirect: string })?.redirect || '/'} />
			)}
			<main className={background()}>
				<div className={container()}>
					<Link to='/'>
						<Icon title='logo DLS' name='logo' width={116} height={50} />
					</Link>

					<div className='titles'>
						<h4>Seja bem vindo!</h4>
						<p>Realize o login para continuar.</p>
					</div>

					<form onSubmit={onSubmit}>
						<Input
							placeholder='Email'
							error={errors.email?.message}
							{...register('email')}
						/>
						<Input
							placeholder='Senha'
							type='password'
							error={errors.password?.message}
							{...register('password')}
						/>

						<Button onClick={onSubmit}>Entrar</Button>
					</form>

					<Link className='link' to='/recuperar-senha'>
						Esqueceu a senha?
					</Link>

					<Link className='link' to='/recuperar-senha?new=true'>
						É seu primeiro acesso?
					</Link>

					<h5>
						Não tem cadastro aqui?{' '}
						<Link className='link' to='/cadastre-se'>
							Cadastre-se!
						</Link>
					</h5>
				</div>

				<SliderLogin />
			</main>
			<ToastError />
		</PageTransition>
	)
}
